export const actionType = {
  GET_FINANCIAL_MODEL: "GET_FINANCIAL_MODEL",
  GET_FINANCIAL_MODEL_SUCCESS: "GET_FINANCIAL_MODEL_SUCCESS",
  GET_FINANCIAL_MODEL_FAILED: "GET_FINANCIAL_MODEL_FAILED",
}

const initialState = {
  data: null,
  meta: null,
  isLoading: false,
  error: null,
  toast: null
}

export const actionCreators = {
  getFinancialModel: (id, params) => {
    return { type: actionType.GET_FINANCIAL_MODEL, id, params }
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_FINANCIAL_MODEL:
      return Object.assign({}, state, {
        isLoading: true,
        error: null
      })
    case actionType.GET_FINANCIAL_MODEL_SUCCESS:
      return Object.assign({}, state, {
        data: action.payload,
        isLoading: false,
        error: null
      })
    case actionType.GET_FINANCIAL_MODEL_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        isLoading: false
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/company/pages/financial-model/reducer.js